import React from 'react'
import classNames from 'classnames'
import { Grid, GridItem } from '@deal/components'
import { useNavigationContext } from '#src/components/Header/StandardHeader/NavigationContext'
import { DepartmentNavigationLinkFragment } from '#src/components/Header/NavHierarchyFragments.generated'
import { useExperiment } from '@deal/experiment-js'
import { FlatDepartment } from '../../../../types'
import TopLists from '#src/components/Header/StandardHeader/TopLists'
import ArrowRight from '#src/components/Header/StandardHeader/icons/arrow-right.svg'
import MenuHeader from '../MenuHeader'
import styles from './styles.css'

interface ActiveCategoriesMenuProps {
  onNavItemSelected: (link: DepartmentNavigationLinkFragment) => void
  flatDepartments: FlatDepartment[]
}

const ActiveCategoriesMenu: React.FC<ActiveCategoriesMenuProps> = ({
  onNavItemSelected,
  flatDepartments
}) => {
  const navContext = useNavigationContext()

  // Don't track experiment viewed event unless mobile menu visible
  const { result: navBrowseTopListResult } = useExperiment({
    experiment: 'nav-browse-top-list',
    defaultTreatment: 'off',
    options: {
      skip: !navContext?.isMobileBrowseMenuVisible
    }
  })

  const currentFlatDepartment = flatDepartments.find(
    flatDepartment => flatDepartment.referenceSlug === navContext?.activeDepartmentSlug
  )

  const filteredTopLevelItems = currentFlatDepartment?.topLevelItems.filter(
    item => item.showIfSmallSize
  )

  return (
    <div
      className={classNames(styles.menu, {
        [styles.visible]: !!navContext?.activeDepartmentSlug && !!currentFlatDepartment
      })}
    >
      <Grid>
        <GridItem col={2}>
          <MenuHeader
            onBack={() => {
              navContext?.onSetActiveDepartmentSlug(null)
            }}
            header={currentFlatDepartment?.displayName}
            testId="mobile-category-menu-header"
          />
          <ul className={styles.list}>
            {filteredTopLevelItems?.map(item => {
              const subSections = item.subSections.filter(
                subSection => !!subSection.showIfSmallSize
              )

              const triggersChildList = subSections.length > 0

              return (
                <li
                  key={`mobile${item.id}`}
                  className={styles.listItem}
                  onClick={() => {
                    if (subSections.length > 0) {
                      navContext?.onSetActiveCategory(item)
                      navContext?.onSetActiveSubSections(subSections)
                    } else {
                      item.labelLink && onNavItemSelected(item.labelLink)
                    }
                  }}
                >
                  <span className={styles.listItemContents}>
                    <span className={styles.listItemLabel}>{item.label}</span>
                    <span
                      className={classNames(styles.listItemIcon, {
                        [styles.hiddenArrow]: !triggersChildList
                      })}
                    >
                      <ArrowRight />
                    </span>
                  </span>
                </li>
              )
            })}
          </ul>
          {navBrowseTopListResult === 'v1' && <TopLists className={styles.topList} />}
        </GridItem>
      </Grid>
    </div>
  )
}

export default ActiveCategoriesMenu
